function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.08 6.02a.89.89 0 01-1.166 1.338l-.091-.08a.802.802 0 00-1.132 0L2.01 11.96a.794.794 0 00-.232.565c0 .216.082.416.232.566l.874.875a.802.802 0 001.132 0l2.799-2.8a.889.889 0 011.257 1.258l-2.799 2.799a2.557 2.557 0 01-1.823.752 2.56 2.56 0 01-1.823-.752l-.874-.875A2.56 2.56 0 010 12.525c0-.69.267-1.338.753-1.822L5.434 6.02c.971-.971 2.675-.971 3.646 0zM14.373.73l.873.874c.486.485.753 1.133.753 1.823s-.267 1.338-.753 1.823l-4.68 4.681a2.56 2.56 0 01-1.824.753A2.56 2.56 0 016.92 9.93a.889.889 0 011.167-1.337l.09.08a.802.802 0 001.133 0l4.68-4.681a.794.794 0 00.232-.566.794.794 0 00-.232-.566l-.873-.874a.802.802 0 00-1.133 0L9.29 4.68a.889.889 0 01-1.256-1.257L10.727.729c.97-.972 2.675-.972 3.646 0z"
});

function SvgCopy(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

export default SvgCopy;